import { useSelector } from "react-redux";
import { URLS } from "../API/API endpoints";
import axiosInstance from "../AxiosInstance";
import i18next from "i18next";
import { toast } from "react-toastify";
import { t } from "i18next"



export const getProductGroups = async (payload) => {
    try {
        const response = await axiosInstance.post(URLS.GET_PRODUCT_GROUPS, payload);
        return response?.data;
    } catch (error) {
        console.error("Error fetching product groups:", error);
        throw error;
    }
};


export const getGroupProducts = async (payload) => {
    try {
        const response = await axiosInstance.post(URLS.GET_GROUP_PRODUCT, payload);
        return response?.data;
    } catch (error) {
        console.error("Error fetching product groups:", error);
        throw error;
    }
};


export const updateProductGroup = async (payload) => {
    try {
        const response = await axiosInstance.post(URLS.UPDATE_PRODUCT_GROUP, payload);
        return response?.data;
    } catch (error) {
        console.error("Error updating product group:", error);
        throw error;
    }
};

export const deleteProductGroup = async (payload) => {
    try {
        const response = await axiosInstance.post(URLS.DELETE_PRODUCT_GROUP, payload);
        return response?.data;
    } catch (error) {
        console.error("Error deleting product group:", error);
        throw error;
    }
};